const backendUrl = import.meta.env.VITE_API_SERVER || '//localhost:5001';
const playContentUrl = import.meta.env.VITE_PLAY_CONTENT_URL || '//localhost:8080';

const Constants = {
  BACKEND_URL: backendUrl,
  PLAY_CONTENT_URL: playContentUrl,
  GAME_SERVER_URL: import.meta.env.VITE_GAME_SERVER_URL || '//localhost:8081',
  SUPER_ROLE: 'timocco admin',
  REGIONAL_ADMIN_ROLE: 'regional admin',
  ADMIN_ROLE: 'organization admin',
  THERAPIST_ROLE: 'therapist',
  ADMIN_ROLE_LEVEL: 0,
  PLAYER_ROLE_LEVEL: 25,
  CARE_PARTNER_ROLE_LEVEL: 15,
  ORGANIZATION_ADMIN_ROLE_LEVEL: 5,
  REGIONAL_ADMIN_ROLE_LEVEL: 4,
  BUSINESS_GROUP_ADMIN_ROLE_LEVEL: 3,
  THERAPIST_ROLE_LEVEL: 10,
  CNA_ROLE_LEVEL: 11,
  HTTP_OK: 200,
  HTTP_UNAUTHORIZED: 401,
  HTTP_NOT_FOUND: 404,
  HTTP_FORBIDDEN: 403,
  RESULTS_PAGE_SIZE: 3,
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  SPLITIO_TREATMENT_OVERRIDE: import.meta.env.VITE_SPLITIO_TREATMENT_OVERRIDE || false,
  SPLIT_IO_LOCAL_TREATMENTS: import.meta.env.VITE_SPLITIO_LOCAL_TREATMENTS
    ? JSON.parse(import.meta.env.VITE_SPLITIO_LOCAL_TREATMENTS)
    : {},
  SSO_REDIRECT_URLS: import.meta.env.VITE_SSO_REDIRECT_URLS ? JSON.parse(import.meta.env.VITE_SSO_REDIRECT_URLS) : {},
  CS_EMAIL: 'cs@restoreskills.com',
  CS_PHONE: '(917) 267-9393',
  OTP_CODE_LENGTH: 6,
  USER_ROLES: {
    TIMOCCO_ADMIN: { id: 1, name: 'Timocco Admin', level: 0 },
    ORGANIZATION_ADMIN: { id: 2, name: 'Organization Admin', level: 5 },
    THERAPIST: { id: 3, name: 'Therapist', level: 10 },
    HOME_PLAYER: { id: 4, name: 'Home Player', level: 25 },
    CARE_PARTNER: { id: 6, name: 'Care Partner', level: 15 },
    BUSINESS_GROUP_ADMIN: { id: 7, name: 'Business Group Admin', level: 3 },
    REGIONAL_ADMIN: { id: 8, name: 'Regional Admin', level: 4 },
    ETL_SERVICE: { id: 9, name: 'ETL Service', level: 2 },
    ANONYMOUS: { id: 10, name: 'Anonymous', level: 100 },
    CNA: { id: 11, name: 'Certified Nursing Assistant', level: 11 },
  },
};

export const fixProtocol = (url) => `${url.startsWith('http') ? '' : window.location.protocol}${url}`;

export default Constants;
